/**
 * Instant Search with Debouncing
 * Real-time search results with 300ms debounce
 */

let searchTimeout = null;

/**
 * Debounce function to limit search frequency
 */
function debounce(func, delay) {
  return function(...args) {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => func.apply(this, args), delay);
  };
}

/**
 * Perform instant search via AJAX
 */
function performInstantSearch(query) {
  const $resultsContainer = $('#search-results');
  
  // Show loading state
  $resultsContainer.html('<div class="loading">Searching...</div>');
  
  $.ajax({
    url: '/ajax/instant-search.php',
    method: 'GET',
    data: { q: query },
    dataType: 'json',
    success: function(response) {
      if (response.success && response.results.length > 0) {
        let html = '<table class="results-table"><thead><tr>' +
                   '<th>Place</th><th>Name</th><th>City</th>' +
                   '<th>Time</th></tr></thead><tbody>';
        
        response.results.forEach(runner => {
          const genderClass = runner.gender === 'M' ? 'genderM' : 'genderF';
          html += `<tr class="${genderClass}">` +
                  `<td>${runner.place}</td>` +
                  `<td>${runner.name}</td>` +
                  `<td>${runner.city}, ${runner.state}</td>` +
                  `<td>${runner.time}</td>` +
                  `</tr>`;
        });
        
        html += '</tbody></table>';
        
        if (response.total > response.results.length) {
          html += `<p class="search-meta">Showing ${response.results.length} of ${response.total} results</p>`;
        }
        
        $resultsContainer.html(html);
      } else {
        $resultsContainer.html('<p class="no-results">No results found</p>');
      }
    },
    error: function(xhr, status, error) {
      console.error('Search error:', error);
      $resultsContainer.html('<p class="error">Search failed. Please try again.</p>');
    }
  });
}

// Initialize instant search on DOM ready
$(document).ready(function() {
  const $searchInput = $('#runner-search');
  
  if ($searchInput.length) {
    // Attach debounced search handler
    const debouncedSearch = debounce(function() {
      const query = $(this).val().trim();
      
      if (query.length >= 2) {
        performInstantSearch(query);
      } else if (query.length === 0) {
        $('#search-results').html('');
      }
    }, 300); // 300ms debounce delay
    
    $searchInput.on('input', debouncedSearch);
    
    // Clear results on form reset
    $searchInput.closest('form').on('reset', function() {
      $('#search-results').html('');
    });
  }
});
